import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

export const FORMAT_DATE_FULL = 'dddd, MMMM D'
export const FORMAT_YEAR_MONTH_DAY = 'YYYY-MM-DD'
export const FORMAT_MONTH_DAY = 'MMM D'
export const FORMAT_MONTH_DAY_LONG = 'MMMM D'
export const FORMAT_MONTH_DAY_YEAR = 'MMM D, YYYY'
export const FORMAT_MONTH_YEAR = 'MMM YYYY'
export const FORMAT_MONTH_FULL = 'MMMM'
export const FORMAT_TIME = 'HH:mm'
export const FORMAT_DATE_MONTH_YEAR = 'MMMM D, YYYY'

// Parses an API datetime string in its declared source timezone and converts to the user's local timezone.
export const parseEventDate = (dateTime: string, sourceTimezone: string) =>
  dayjs.tz(dateTime, sourceTimezone).local()
